<template>
	<v-container class="my-raports-container">
		<div>
			<virtual-list class="my-raports-list-wrapper" style="height: 90%" :size="leng" :remain="leng">
				<div v-for="(report, index) of reports" :key="index" @click="openReportDetails(report.id)">
					<OtherRaportCard :key="report.id" :reports_info="report" :make_reply="false" :status="getStatus(report.status)" :color_by_status="getColorByStatus(report.status)" />
				</div>
			</virtual-list>
		</div>
		<ViewReportDetail :showdetailsdialog="showdetailsdialog" :item="report_details" :ismyreports="ismyreports"></ViewReportDetail>
	</v-container>
</template>

<script>
import OtherRaportCard from '@/components/cards/OtherRaportCard.vue';
import reports from '@/config/api/api_events/reports.js';
import virtualList from 'vue-virtual-scroll-list';
import ViewReportDetail from '../view_report_detail/ViewReportDetail.vue';

export default {
	name: 'OtherRaports',
	components: {
		OtherRaportCard,
		ViewReportDetail,
		'virtual-list': virtualList,
	},
	props: {
		make_request_for_data: {
			type: [Boolean],
			default: true,
		},
		pre_inited_data: {
			type: [Array],
		},
		color_by_status: {
			type: [String],
			required: false,
		},
		make_reply: {
			type: [Boolean],
			required: false,
			default: false,
		},
		ismyreports: {
			type: [Boolean],
			required: false,
			default: false,
		},
	},
	data() {
		return {
			leng: 531,
			reports: [],
			status: [],
		};
	},
	computed: {
		showdetailsdialog() {
			let showdetailsdialog = false;
			if (this.ismyreports) {
				showdetailsdialog = this.$route.name == 'ViewMyReportDetail' || this.$route.name == 'ViewMyReportPhotos';
			} else {
				showdetailsdialog = this.$route.name == 'ViewReportDetail' || this.$route.name == 'ViewReportPhotos';
			}
			//console.log(showdetailsdialog)
			return showdetailsdialog;
		},
		report_details() {
			let foundreport = null;
			if ((this.$route.name == 'ViewReportDetail' || this.$route.name == 'ViewMyReportDetail') && this.$route.params.id) {
				foundreport = this.reports.find((report) => report.id == this.$route.params.id);
			}
			return foundreport;
		},
	},
	watch: {
		$route(to, from) {
			if (to.name == 'ViewReportDetail' || from.name == 'ViewReportDetail' || this.$route.name == 'ViewMyReportDetail' || this.$route.name == 'ViewMyReportPhotos') {
				this.$store.state.active_loader = false;
			}
		},
	},
	mounted() {
		if (this.make_request_for_data) {
			this.getPublicReportsfromCall();
		} else {
			this.reports = this.pre_inited_data;
		}
	},
	methods: {
		getPublicReportsfromCall() {
			reports
				.getPublicReports()
				.then((response) => {
					this.leng = response.report.length;
					this.status = response.status;
					this.reports = response.report;
					this.$store.state.active_loader = false;
				})
				.catch((error) => {
					this.$store.state.active_loader = false;
					console.log('There was an error:', error);
				});
		},
		getStatus(status) {
			var status_to_return = this.status.filter((el) => el.id == status)[0];
			return status_to_return != undefined ? status_to_return : null;
		},
		getColorByStatus(status) {
			var color_to_return = this.status.filter((el) => el.id == status)[0];
			return color_to_return != undefined ? color_to_return.color : this.color_by_status;
		},
		openReportDetails(report_id) {
			let routename = this.ismyreports ? 'ViewMyReportDetail' : 'ViewReportDetail';
			//console.log(report_id, routename)
			this.$router.push({
				name: routename,
				params: { id: report_id },
			});
		},
	},
};
</script>

<style lang="scss">
.hooper-raporte-wrapper {
	.hooper-list {
		.hooper-track {
			height: 100% !important;
			.slide-raporte {
				height: auto !important;
				width: 100%;
				opacity: 1 !important;
			}
		}
	}
}

.my-raports-list-wrapper {
	height: calc(100vh - 235px) !important;
}
</style>
